import { ANALYTICS_PROVIDER } from "@/features/analytics/models";
import { handleAnalyticsError } from "@/features/analytics/utils";
import { privateAPI, publicAPI } from "@/shared/lib";

interface TrackEventPayload {
  event: string;
  properties?: Record<string, unknown>;
  userId?: string;
}

export const trackPublicEvent = (payload: TrackEventPayload): void => {
  void publicAPI.post("/analytics/public/track", payload).catch((error) =>
    handleAnalyticsError(error, {
      message: "Error tracking public analytics event",
      provider: ANALYTICS_PROVIDER.CUSTOMER_IO,
      extra: { event: payload.event },
    }),
  );
};

export const trackPrivateEvent = (payload: TrackEventPayload): void => {
  void privateAPI.post("/analytics/private/track", payload).catch((error) =>
    handleAnalyticsError(error, {
      message: "Error tracking private analytics event",
      provider: ANALYTICS_PROVIDER.CUSTOMER_IO,
      extra: { event: payload.event },
    }),
  );
};
